import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function GuaranteePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const coverageItems = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'ペットの怪我・治療費',
      desc: 'シッティング中の偶発的な事故でペットが負傷した場合、獣医治療費を最大 200 ユーロまで補償します。',
      covered: true,
    },
    {
      icon: 'ri-virus-line',
      title: '持病・既往症',
      desc: 'もともとある病気や持病の悪化は対象外です。シッティング中に起きた新たな怪我のみが対象になります。',
      covered: false,
    },
    {
      icon: 'ri-old-bridge-line',
      title: '老化・自然な体調変化',
      desc: '年齢による体調変化や老化に伴う症状は保証の対象外です。',
      covered: false,
    },
    {
      icon: 'ri-syringe-line',
      title: '未接種による感染症',
      desc: '予防接種を受けていないことが原因の感染症は補償されません。ワクチン接種の確認をお願いします。',
      covered: false,
    },
  ];

  const steps = [
    {
      step: '01',
      icon: 'ri-alarm-warning-line',
      title: '24時間以内に報告',
      desc: '事故発生後、すぐにPawBridgeサポートへ連絡してください。報告期限は事故から24時間以内です。',
    },
    {
      step: '02',
      icon: 'ri-file-text-line',
      title: '必要書類を用意',
      desc: '獣医師の診断書・領収書・事故の状況説明の3点を準備してください。',
    },
    {
      step: '03',
      icon: 'ri-send-plane-line',
      title: '書類を提出',
      desc: 'サポートチームが書類を確認し、補償の可否と金額を合理的に判断してお知らせします。',
    },
    {
      step: '04',
      icon: 'ri-bank-card-line',
      title: '補償金を受け取る',
      desc: '審査通過後、治療費の一部として最大200ユーロが支払われます。',
    },
  ];

  const conditions = [
    {
      icon: 'ri-check-double-line',
      text: 'PawBridgeプラットフォーム経由で予約・決済が完了していること',
    },
    {
      icon: 'ri-check-double-line',
      text: '事故発生後24時間以内にPawBridgeへ報告すること',
    },
    {
      icon: 'ri-check-double-line',
      text: 'シッターが通常の注意義務を果たしていること',
    },
  ];

  const articles = [
    { title: '第1条（目的）', content: 'PawBridgeが提供するペットシッティング仲介サービスにおいて、利用者に安心してサービスをご利用いただくために提供する「安心保証制度」について定めるものです。' },
    { title: '第2条（適用範囲）', content: '本保証は、当社プラットフォーム上で予約および決済が完了したペットシッティングに限り適用されます。プラットフォーム外での直接取引には適用されません。' },
    { title: '第3条（当社の立場）', content: '当社はペットシッターと飼い主のマッチングを行う仲介プラットフォームであり、ペットシッティングサービスの提供者ではありません。実際のサービス提供に関する責任は、シッターおよび飼い主双方に帰属します。' },
    { title: '第4条（保証内容）', content: 'シッティング期間中に発生した偶発的かつ予期しない事故によりペットが負傷した場合に限り、当該治療費の一部を補償します。' },
    { title: '第5条（補償上限）', content: '本保証による補償額は、1件あたり最大200ユーロを上限とします。' },
    { title: '第6条（保証料）', content: '本保証は、1日あたり2ユーロの保証料として、予約料金に含まれます。なお、保証料には上限が設定される場合があります。' },
    { title: '第7条（適用条件）', content: '①当社プラットフォームを通じて予約および支払いが完了していること ②事故発生後24時間以内に当社へ報告が行われること ③シッターが通常求められる注意義務を果たしていること' },
    { title: '第8条（補償対象外）', content: '既往症・老化・飼い主の指示違反・故意または重大な過失・予防接種未実施による感染症・通常予見可能な軽微な傷・プラットフォーム外の取引や事故は対象外です。' },
    { title: '第9条（請求手続き）', content: '補償を受けるには、獣医師による診断書・治療費の領収書・事故の状況説明を提出する必要があります。' },
    { title: '第10条（補償の決定）', content: '補償の可否および金額については、提出された資料をもとに当社が合理的に判断します。' },
    { title: '第11条（免責事項）', content: '当社は、本保証の範囲を超える損害について一切の責任を負いません。また、本保証はすべての損害を完全に補填するものではありません。' },
    { title: '第12条（規約の変更）', content: '当社は、必要に応じて本規約を変更することができます。変更後の規約は、当社ウェブサイト上に掲載した時点で効力を生じます。' },
  ];

  const [showLegal, setShowLegal] = useState(false);

  return (
    <div className="min-h-screen bg-[#F5FAF9] font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-[#81D8D0]/95 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-20 sm:h-24">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-36 h-36 sm:w-40 sm:h-40 object-contain brightness-0"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/sitters" className={`relative text-sm transition-colors whitespace-nowrap group ${scrolled ? 'text-[#1B2A4A]/70 hover:text-[#1B2A4A]' : 'text-white hover:text-white'}`}>
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-current rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitter-registration" className={`relative text-sm transition-colors whitespace-nowrap group ${scrolled ? 'text-[#1B2A4A]/70 hover:text-[#1B2A4A]' : 'text-white hover:text-white'}`}>
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-current rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/login" className={`relative text-sm transition-colors whitespace-nowrap group ${scrolled ? 'text-[#1B2A4A]/70 hover:text-[#1B2A4A]' : 'text-white hover:text-white'}`}>
                ログイン
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-current rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/booking" className={`px-6 py-2.5 text-sm font-medium rounded-full transition-all whitespace-nowrap ${scrolled ? 'bg-[#81D8D0] text-white hover:bg-[#6FC5BD]' : 'bg-white text-[#81D8D0] hover:bg-white/90'}`}>
                予約する
              </Link>
            </div>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-[#1B2A4A]' : 'text-white'}`}
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="md:hidden pb-4 space-y-3 border-t border-white/20 pt-3">
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white py-2">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white py-2">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white py-2">ログイン</Link>
              <Link to="/booking" onClick={() => setMobileMenuOpen(false)} className="block px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full text-center">予約する</Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-20 sm:pt-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/3994172a7e74a3907c9fa21a1aab2dc4.jpg"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1B2A4A]/50 via-[#1B2A4A]/40 to-[#F5FAF9]"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-xs font-medium px-4 py-1.5 rounded-full mb-6">
            <i className="ri-shield-check-fill text-[#81D8D0]"></i>
            PawBridge 安心保証
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            大切なペットを、<br className="sm:hidden" />安心して<br className="hidden sm:block" />預けられる仕組みがあります
          </h1>
          <p className="text-white/80 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            PawBridgeの全予約には保証が自動で付帯。<br />
            万が一の事故でも、治療費を最大200ユーロまでカバーします。
          </p>
        </div>
      </section>

      {/* Key numbers */}
      <section className="max-w-5xl mx-auto px-4 md:px-6 -mt-6 mb-16 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: 'ri-shield-star-line', num: '200', unit: 'ユーロまで補償', sub: '1件あたりの治療費上限' },
            { icon: 'ri-coins-line', num: '2', unit: 'ユーロ/日', sub: '料金に自動で含まれる保証料' },
            { icon: 'ri-timer-line', num: '24', unit: '時間以内', sub: '事故報告の期限' },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 text-center border border-[#D4EEEb]">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#81D8D0]/15 mx-auto mb-3">
                <i className={`${item.icon} text-2xl text-[#81D8D0]`}></i>
              </div>
              <p className="text-2xl font-bold text-[#1B2A4A]">{item.num}<span className="text-base font-medium ml-1 text-[#1B2A4A]/70">{item.unit}</span></p>
              <p className="text-xs text-[#1B2A4A]/50 mt-1">{item.sub}</p>
            </div>
          ))}
        </div>
      </section>

      {/* What is guarantee */}
      <section className="max-w-5xl mx-auto px-4 md:px-6 mb-20">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-xs font-semibold text-[#81D8D0] uppercase tracking-widest mb-3">安心保証とは</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-5 leading-snug">
              追加手続き不要。<br />予約するだけで自動で保護されます。
            </h2>
            <p className="text-[#1B2A4A]/70 text-sm sm:text-base leading-relaxed mb-5">
              PawBridgeで予約・決済を行うと、保証料（1日2ユーロ）が料金に自動で含まれます。別途申し込みや書類提出は不要。ペットに万が一の事故があった際は、サポートに連絡するだけで手続きを進められます。
            </p>
            <p className="text-[#1B2A4A]/70 text-sm sm:text-base leading-relaxed">
              プラットフォーム外の直接取引には保証が適用されません。安心のために、必ずPawBridge経由でご予約ください。
            </p>
          </div>
          <div className="relative rounded-2xl overflow-hidden h-64 sm:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=cute%20fluffy%20dog%20being%20gently%20held%20by%20caring%20person%20indoors%2C%20warm%20soft%20indoor%20lighting%2C%20cozy%20home%20environment%2C%20white%20and%20beige%20tones%2C%20peaceful%20and%20safe%20atmosphere%2C%20professional%20pet%20care%2C%20high%20quality%20photography&width=600&height=480&seq=guarantee-care-01&orientation=portrait"
              alt="安心して預けられるペットケア"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4A]/20 to-transparent"></div>
          </div>
        </div>
      </section>

      {/* Coverage */}
      <section className="bg-white py-16 mb-20">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <p className="text-xs font-semibold text-[#81D8D0] uppercase tracking-widest mb-3">保証の範囲</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A]">何が保証されて、何が対象外か</h2>
            <p className="text-[#1B2A4A]/60 text-sm mt-3">事前に確認して、安心してサービスをご利用ください</p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {coverageItems.map((item, i) => (
              <div key={i} className={`rounded-2xl p-5 border ${item.covered ? 'bg-[#F0FBF9] border-[#81D8D0]/40' : 'bg-[#FFF8F5] border-orange-200'}`}>
                <div className="flex items-start gap-4">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-full flex-shrink-0 ${item.covered ? 'bg-[#81D8D0]/20' : 'bg-orange-100'}`}>
                    <i className={`${item.icon} text-xl ${item.covered ? 'text-[#81D8D0]' : 'text-orange-400'}`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1.5">
                      <p className="text-sm font-bold text-[#1B2A4A]">{item.title}</p>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${item.covered ? 'bg-[#81D8D0]/20 text-[#2E8B84]' : 'bg-orange-100 text-orange-600'}`}>
                        {item.covered ? '保証対象' : '対象外'}
                      </span>
                    </div>
                    <p className="text-xs sm:text-sm text-[#1B2A4A]/65 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Other exclusions */}
          <div className="mt-6 bg-[#FFF8F5] border border-orange-200 rounded-2xl p-5">
            <div className="flex items-center gap-2 mb-3">
              <i className="ri-error-warning-line text-orange-400 text-lg"></i>
              <p className="text-sm font-bold text-[#1B2A4A]">その他の対象外ケース</p>
            </div>
            <div className="grid sm:grid-cols-2 gap-2">
              {[
                '飼い主の指示違反または不適切な指示に起因する事故',
                'シッターまたは飼い主による故意または重大な過失',
                '通常予見可能な軽微な傷や擦り傷',
                'プラットフォーム外で発生した取引や事故',
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-orange-400 text-sm mt-0.5 flex-shrink-0"></i>
                  <p className="text-xs text-[#1B2A4A]/65">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Conditions */}
      <section className="max-w-5xl mx-auto px-4 md:px-6 mb-20">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-[#81D8D0] uppercase tracking-widest mb-3">適用条件</p>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A]">保証が適用される3つの条件</h2>
          <p className="text-[#1B2A4A]/60 text-sm mt-3">すべての条件を満たした場合のみ保証が適用されます</p>
        </div>
        <div className="grid sm:grid-cols-3 gap-4">
          {conditions.map((c, i) => (
            <div key={i} className="bg-white border border-[#D4EEEb] rounded-2xl p-5 flex gap-3 items-start">
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#81D8D0]/20 flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-sm text-[#81D8D0] font-bold"></i>
              </div>
              <p className="text-sm text-[#1B2A4A]/80 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How to claim */}
      <section className="bg-[#1B2A4A] py-16 mb-20">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <p className="text-xs font-semibold text-[#81D8D0] uppercase tracking-widest mb-3">請求方法</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-white">もしもの時の4ステップ</h2>
            <p className="text-white/50 text-sm mt-3">シンプルな手続きで補償を受け取れます</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={i} className="relative">
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-white/10 z-0" style={{ width: 'calc(100% - 2.5rem)', left: '2.5rem' }}></div>
                )}
                <div className="bg-white/8 border border-white/10 rounded-2xl p-5 relative z-10">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-3xl font-bold text-[#81D8D0]/30">{s.step}</span>
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#81D8D0]/20">
                      <i className={`${s.icon} text-lg text-[#81D8D0]`}></i>
                    </div>
                  </div>
                  <p className="text-sm font-bold text-white mb-2">{s.title}</p>
                  <p className="text-xs text-white/55 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-4 md:px-6 mb-20">
        <div className="bg-gradient-to-br from-[#81D8D0] to-[#5BBFB5] rounded-3xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-5">
            <i className="ri-shield-check-line text-3xl text-white"></i>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            安心保証付きで、今日から始めましょう
          </h2>
          <p className="text-white/80 text-sm sm:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            追加費用なし、別途申込不要。PawBridgeで予約するだけで、大切なペットが保護されます。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/sitters" className="px-8 py-3 bg-white text-[#2E8B84] text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap">
              シッターを探す
            </Link>
            <Link to="/contact" className="px-8 py-3 border-2 border-white text-white text-sm font-medium rounded-full hover:bg-white/10 transition-all whitespace-nowrap">
              お問い合わせ
            </Link>
          </div>
        </div>
      </section>

      {/* Legal toggle */}
      <section className="max-w-5xl mx-auto px-4 md:px-6 mb-20">
        <button
          onClick={() => setShowLegal(!showLegal)}
          className="w-full flex items-center justify-between bg-white border border-[#D4EEEb] rounded-2xl px-6 py-4 cursor-pointer hover:bg-[#F0FBF9] transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#81D8D0]/15">
              <i className="ri-file-text-line text-[#81D8D0] text-lg"></i>
            </div>
            <div className="text-left">
              <p className="text-sm font-bold text-[#1B2A4A]">安心保証規約（正式条文）</p>
              <p className="text-xs text-[#1B2A4A]/50">施行日：2026年3月29日</p>
            </div>
          </div>
          <i className={`${showLegal ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xl text-[#1B2A4A]/40 transition-transform`}></i>
        </button>

        {showLegal && (
          <div className="mt-3 bg-white border border-[#D4EEEb] rounded-2xl p-6 md:p-8 space-y-6">
            {articles.map((a, i) => (
              <div key={i} className={i > 0 ? 'border-t border-[#EEF6F5] pt-6' : ''}>
                <h3 className="text-sm font-bold text-[#1B2A4A] mb-2">{a.title}</h3>
                <p className="text-xs text-[#1B2A4A]/65 leading-relaxed">{a.content}</p>
              </div>
            ))}
            <div className="border-t border-[#EEF6F5] pt-6">
              <h3 className="text-sm font-bold text-[#1B2A4A] mb-2">附則</h3>
              <p className="text-xs text-[#1B2A4A]/65">本規約は2026年3月29日より施行します。</p>
            </div>
          </div>
        )}
      </section>

      {/* Back links */}
      <div className="max-w-5xl mx-auto px-4 md:px-6 pb-12 flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors">
          <i className="ri-arrow-left-line"></i>ホームに戻る
        </Link>
        <span className="hidden sm:block text-[#1B2A4A]/20">|</span>
        <Link to="/terms" className="inline-flex items-center gap-2 text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors">
          利用規約を見る<i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 md:pt-20 pb-8 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="h-28 md:h-36 mb-4 md:mb-5 brightness-0"
              />
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">海外在住日本人のためのペットシッターコミュニティ</p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/sitters" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター検索</Link></li>
                <li><Link to="/sitter-registration" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター登録</Link></li>
                <li><Link to="/booking" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">料金</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/about" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridgeについて</Link></li>
                <li><Link to="/contact" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">お問い合わせ</Link></li>
                <li><Link to="/terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 利用規約</Link></li>
                <li><Link to="/sitter-terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge シッター利用規約</Link></li>
                <li><Link to="/guarantee" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 安心保証規約</Link></li>
                <li><Link to="/privacy" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-white/30 text-center">
            <p className="text-xs text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
